module.exports = __webpack_public_path__ + "static/media/break.187af04f.png";